import { IconWrapper } from '../runtime';
export default IconWrapper('bill', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M11 3.24976H12.25C12.8023 3.24976 13.25 3.69747 13.25 4.24976V13.2498C13.25 13.802 12.8023 14.2498 12.25 14.2498H3.75C3.19772 14.2498 2.75 13.802 2.75 13.2498V4.24976C2.75 3.69747 3.19772 3.24976 3.75 3.24976H5M11 3.24976V2.74976C11 2.19747 10.5523 1.74976 10 1.74976H6C5.44772 1.74976 5 2.19747 5 2.74976V3.24976M11 3.24976C11 3.80204 10.5523 4.24976 10 4.24976H6C5.44772 4.24976 5 3.80204 5 3.24976M5.5 7.24976H10.5M5.5 10.2498H10.5",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});